import type { SVGProps } from "react";

export function Lightbulb(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M9 18h6" />
      <path d="M10 22h4" />
      <path d="M12 2a7 7 0 0 0-4 12c1 .9 1 1.7 1 3h6c0-1.3 0-2.1 1-3a7 7 0 0 0-4-12z" />
    </svg>
  );
}
